import { Brick, registerBrick, ErrorFlow } from 'olympe';

export default class GetVideoStream extends Brick {

    static loading = false;

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} camera
     * @param {function(*)} setVideoStream
     */
    update($, [camera], [setVideoStream]) {
        GetVideoStream.initialize($, camera, setVideoStream);
    }

    static initialize($, camera, setVideoStream){
        if (camera === 'back camera' || camera === 'front camera') {
            GetVideoStream.requestVideo($, camera === 'back camera' ? 'environment' : 'user', setVideoStream);
        } else {
            const stream = $.get('get-video-internal-stream');
            if (stream) {
                stream.getTracks().forEach((track) => {
                    track.stop();
                });
                $.set('get-video-internal-stream', null);
            }
        }
    }


    static requestVideo($, facingMode, setVideoStream) {
        // There are conflicts if 2 bricks loads the getUserMedia at the same time, so we delay the demand in case of conflicts
        if (GetVideoStream.loading) {
            setTimeout(() => this.requestVideo($, facingMode, setVideoStream), 200);
        } else {
            GetVideoStream.loading = true;

            navigator?.mediaDevices?.getUserMedia({
                    video: { facingMode: facingMode },
                    audio: false
                })
                .then((stream) => {
                    GetVideoStream.loading = false;
                    $.onDestroy(() => {
                        stream.getTracks().forEach((track) => {
                            track.stop();
                        });
                    });
                    $.set('get-video-internal-stream', stream);
                    setVideoStream(stream);
                })
                .catch((err) => {
                    throw ErrorFlow.create('An error occurred in getting the video stream: '+ err, 1);
                });

        }
    }

}

registerBrick('018dcaeae25281f2e388', GetVideoStream);
